import AppCatalog from "../../../services/App/AppCatalog.js";
import Catalog from "../DbpyCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  VendorID: {
    Label: Catalog.VendorID.Label,
    Type: AppCatalog.Field.ID.Type,
    Input: AppCatalog.Field.ID.Input,
    ReadOnly: true
  },
  VendorName: {
    Label: Catalog.VendorID.Label,
    Type: AppCatalog.Field.Name.Type,
    Required: true
  },
  WarehouseID: {
    Label: Catalog.WarehouseID.Label,
    Type: AppCatalog.Field.ID.Type,
    Input: AppCatalog.Field.ID.Input
  }
}